import HCLTextHandler from "../HCLTextHandler";
import Badge from "./Badge";
import HCLVertexState from "../../HCLCellState/HCLVertexState";

class BadgeHandler extends HCLTextHandler<Badge> {
  constructor(cellState: HCLVertexState) {
    super(Badge, cellState);
  }

  protected shouldTextBeVisible(): boolean {
    return this.cellState.getCell().getGraph().getIDsVisible();
  }
}

export default BadgeHandler;
